<template>
  <div class="v-table-td-credit">
    <v-table-number ref="numberRef"
                    field="creditAmount"
                    :subject="subject"
                    :rowIndex="rowIndex"
                    :originCurrencyId="originCurrencyId"
                    @onEnter="onEnter"
                    @cancel-edit="cancelEdit"
                    :number="number"
                    :numberFor="numberFor"
                    :exchangeRate="exchangeRate"
    />
  </div>
</template>
<script setup>
import VTableNumber from "@components/VoucherTable/VTableNumber.vue";
import {defineExpose, getCurrentInstance, onMounted, ref, watch} from "vue";
import {getVTable} from "@components/VoucherTable/VtUtil";
import {divide, round} from "xe-utils";
import {useStore} from "vuex";

const store = useStore();

const props = defineProps(['credit', 'creditFor', 'rowIndex', 'detail', 'subject']);

const number = ref(null)
const numberFor = ref(null)
const originCurrency = ref(null);
const originCurrencyId = ref(null)
const exchangeRate = ref(null)
const numberRef = ref(null)
let VTable = null;
const currencyMap = store.state.currencyMap;

const cancelEdit = (params) => {
	number.value = params.number;
  numberFor.value = params.numberFor;
	props.detail.price = round(divide(params.number, props.detail.num), 2);
	VTable.exposed.updateFiled(props.rowIndex, 'creditAmount', params.number);
  VTable.exposed.updateFiled(props.rowIndex, 'creditAmountFor', params.numberFor);
  if(params.originCurrency){
    originCurrency.value = params.originCurrency;
    originCurrencyId.value = params.originCurrency.id;
    exchangeRate.value = params.exchangeRate;
    VTable.exposed.updateFiled(props.rowIndex, 'originCurrencyId', params.originCurrency.id);
    VTable.exposed.updateFiled(props.rowIndex, 'exchangeRate', params.exchangeRate);
  }

}

const onEnter = (params) => {

  cancelEdit(params);
	VTable.exposed.next(props.rowIndex + 1, 'summary');
}

watch(() => props.credit, (val) => {
	number.value = val;
})

watch(() => props.creditFor, (val) => {
  numberFor.value = val;
})

watch(() => props.detail.originCurrencyId, (val) => {
  originCurrencyId.value = val;
  if(val){
    originCurrency.value= currencyMap[val];
    exchangeRate.value = currencyMap[val].exchangeRate;
  }
})

onMounted(() => {
	VTable = getVTable(getCurrentInstance())
	number.value = props.credit;
  numberFor.value = props.creditFor;
  originCurrencyId.value = props.detail.originCurrencyId;
  exchangeRate.value = props.detail.exchangeRate;
})

defineExpose({
	doEdit: () => numberRef.value.doEdit(),
	endEdit: () => numberRef.value.cancelEdit()
})
</script>
<style scoped lang="less">
.v-table {

  &-td {
    &-credit {
      width: 241px;
      background-image: url("../../assets/moneyUint2.png");
    }
  }
}
</style>
